export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyC6pe_JbIymkeryeZfvH4q1MXnW71SVY0U",
  authDomain: "weather-management-system.firebaseapp.com",
  databaseURL: "https://weather-management-system-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "weather-management-system",
  storageBucket: "weather-management-system.firebasestorage.app",
  messagingSenderId: "521640129814",
  appId: "1:521640129814:web:5454f803f8a4561163cc37",
  measurementId: "G-KNWPBP6WZQ"
};

export const MQTT_TOPICS = {
  TEMPERATURE: 'weather/temperature',
  HUMIDITY: 'weather/humidity',
  PRESSURE: 'weather/pressure',
  LIGHT: 'weather/light',
  RAIN: 'weather/rain',
  WIND_SPEED: 'weather/wind_speed',
  WIND_DIRECTION: 'weather/wind_direction',
  STATUS: 'weather/status',
  FAN_CONTROL: 'weather/control/fan',
} as const;

export const TIME_RANGES = {
  HOUR: 1,
  SIX_HOURS: 6,
  DAY: 24,
  WEEK: 168,
  MONTH: 720,
} as const;

// Cabuyao, Laguna, Philippines location
export const CABUYAO_LOCATION = {
  lat: 14.2786,
  lng: 121.1242,
  tz: 'Asia/Manila',
};

// Default location for sunrise/sunset (Cabuyao, Laguna, Philippines)
export const SUN_LOCATION = CABUYAO_LOCATION;

